import { render, staticRenderFns } from "./IconThumbDown.vue?vue&type=template&id=4065887c"
import script from "./IconThumbDown.vue?vue&type=script&lang=js"
export * from "./IconThumbDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports